'use strict';
import template from './mx-push-notifications-monitor.component.html';

export class PushNotificationsMonitorController {
	static $inject = ['mx.sb.PushNotifications.NotificationsService', 'mx.sb.PushNotifications.PanelService', 'mx.internationalization', '$scope'];

	constructor(pushNotificationsService, pushNotificationsPanelService, i18n, $scope) {
		this.pushNotificationsService = pushNotificationsService;
		this.pushNotificationsPanelService = pushNotificationsPanelService;
		this.i18n = i18n.get('solutionBuilderAgent.push-notifications');
		this.$scope = $scope;

		Object.defineProperty(this, 'hasAlert', {
			get: () => this.pushNotificationsService.isRequestPermissionsNeeded() || this.pushNotificationsService.isDenied() || !this.pushNotificationsService.isSupported(),
		});
	}

	$onInit() {
		this._unsubscribe = this.pushNotificationsService.addNotificationsUpdatedHandler((notifications) => this._onNotificationsUpdated(notifications));
		this._onNotificationsUpdated(this.pushNotificationsService.notifications);
	}

	$onDestroy() {
		this._unsubscribe();
	}

	_onNotificationsUpdated() {
		this.$scope.$evalAsync();
	}
}

export default {
	template: template,
	controllerAs: 'vm',
	controller: PushNotificationsMonitorController,
};
